import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { pendService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useOpenedPendsMutation = () => {
	const dispatch = useDispatch();

	return useMutation(
		(id: number | string) =>
			pendService.getPendList({ id, excludeStatuses: "closed" }),
		{
			onMutate() {
				dispatch(uiActions.showSpinnerOverlay());
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			onSettled() {
				dispatch(uiActions.hideSpinnerOverlay());
			},
		},
	);
};

export default useOpenedPendsMutation;
